<template>
  <div style="margin-bottom: 4.5rem;">
    <div class="container">
      <div class="section breadcrumb" >
        <div class="header-wrapper">
            <b-breadcrumb
                align="is-left"
            >
                <b-breadcrumb-item tag='router-link' to="/insights/">Insights</b-breadcrumb-item>
                <b-breadcrumb-item tag='router-link' to="/insights/dose-motivation" active>Dose of Motivation</b-breadcrumb-item>
            </b-breadcrumb>
            <div class="pb-title">DOSE OF MOTIVATION</div>
        </div>
      </div>
    </div>
        
    <!-- Content -->
    <div class="container">
      <div class="section py-5">
        <!-- <h1 class="title is-size-3-mobile has-text-left">News & Announcements</h1> -->
        <SearchBar class="news-columns searchbar-margin mb-5" :contentList="articleList" :dropdownList="articleTitleList" @set-content-array="setArticlesAndDataLength"/>
        <div class="columns is-mobile is-tablet is-desktop news-columns is-multiline has-text-left pb-0">
          <template v-if="articles.length > 0">
            <div class="column is-6-mobile is-6-tablet is-4-desktop "  v-for="(article, index) in articles" :key="index">
              <div class="newsDivider">
                <figure class="image is-square" style="cursor: pointer" @click="isImageModalActive(index)" >
                  <img :src="article.attributes.image.data ? article.attributes.image.data.attributes.url : require('@/assets/img/default_photo_big.jpg')">
                </figure>
              </div>
            </div>
          </template>
          <div v-else style="min-height: 100px; margin-inline: auto;">
            No results found.
          </div>
          <div v-if="(articles.length > 0 && (articleSize > dataLength && (dataLength % 6 !== 3)) && counter > 3)" class="column is-hidden-mobile" style="border-top: 1px solid #D3D3D3;"></div>
        </div>

        <!-- LOAD MORE BUTTON -->
        <!-- <div class="pb-6 mt-3 mb-3" v-if="(!hideButton && articles.length > articleSize)" style="position: relative;">
          <a class="text-link pr-6" @click="loadData()" style="position: inherit; color: #5C5D64 !important;">
            LOAD MORE
            <b-icon icon="chevron-down" size="is-small" style="font-size: 20px;"></b-icon>
          </a>
        </div> -->
      </div>

      <!-- PAGINATION -->
      <div class="pb-pagination mb-1 is-hidden-mobile" v-if="pagination.pageCount > 1" >
        <b-pagination
            :total="pagination.total"
            v-model="current"
            range-before="2"
            icon-prev="menu-left"
            icon-next="menu-right"
            range-after="2"
            order="is-centered"
            :per-page="pagination.pageSize"
            @change="updateContentByPage(current)">
        </b-pagination>
      </div> 

      <div class="pb-pagination mb-1 is-hidden-desktop is-hidden-tablet" v-if="pagination.pageCount > 1" >
        <b-pagination
            :total="pagination.total"
            v-model="current"
            range-before="0"
            icon-prev="menu-left"
            icon-next="menu-right"
            range-after="0"
            order="is-centered"
            :per-page="pagination.pageSize"
            @change="updateContentByPage(current)">
        </b-pagination>
      </div> 

    </div>
    <div class="is-flex is-justify-content-end">
      <ScrollTop />
    </div>

    <b-modal v-if="imageModal" v-model="imageModal" :width="1400" scroll="keep" :can-cancel="false">
        <div class="card is-flex" style="background-color: transparent;">
            <div class="card-image">
              <b-button class="btn-close is-hidden-tablet is-hidden-desktop" @click="closeModal" ><b-icon class="ml-1" icon="close" style="color: #363636"></b-icon></b-button>
                <div class="image is-square">
                    <img :src="imageCurr.attributes.image.data ? imageCurr.attributes.image.data.attributes.url : require('@/assets/img/default_photo_big.jpg')" alt="Image">
                </div>
            </div>
            <div class="card-content" style="position:relative; background-color: #FFFFFF;" >
              <b-button class="btn-close is-hidden-mobile" @click="closeModal" ><b-icon class="ml-1" icon="close" style="color: #363636"></b-icon></b-button>
                <div class="content">
                    <div class="text-description pb-title">{{ "“" + imageCurr.attributes.description + "”"}}</div>
                    <div class="author">{{ "-" + imageCurr.attributes.author  }}</div>
                    <div class="yellow-line"></div>
                    <div class="published-date">{{ "Published on " + imageCurr.attributes.publishedBy }}</div>
                </div> 
            </div>
        </div>
    </b-modal>

    <b-loading :is-full-page="isFullPage" v-model="isLoading">
        <b-icon
            pack="mdi"
            icon="loading"
            size="is-large"
            custom-class="mdi-spin">
        </b-icon>
    </b-loading>

  
    </div>
  </template>
  
  <script>
    import ScrollTop from '../../components/ScrollTop.vue';
    import dayjs from 'dayjs';
    import SearchBar from "../../components/SearchBar.vue";
  
    export default {
      components: { ScrollTop, SearchBar },
      data() {
        return {
          hideButton: false,
          dataLength: 0,
          articleSize: 6,
          articles: [],
          articleList: [],
          articleTitleList: [],
          counter: 0,
          imageModal: false,
          imageCurr: {},
          current: 1,
          pagination: {},
          isLoading: false,
          isFullPage: true
        };
      },
      mounted() {
        window.scrollTo(0, 0);
        this.updateContentByPage(1);
      },
  
      methods:{
        closeModal() {
          this.$set(this, 'imageModal', false);
        },
        async updateContentByPage(pageNum) {
          this.isLoading = true 

          this.$httpClientCMS({
            method: 'GET',
            url: 'api/dose-of-motivations?populate=*&pagination[page]='+ pageNum + '&pagination[pageSize]=9' 
          })
          .then(resp => {
            this.isLoading = false 
            window.scrollTo({
              top: 0, 
              behavior: 'smooth',
            });

            let articles = resp.data.data;
            this.$set(this, 'articles', articles);
            this.pagination = resp.data.meta.pagination
            this.dataLength = articles.length;
            this.$set(this, 'articleList', articles);
            this.articleTitleList = articles.map(i => i.attributes.title);
          })
          .catch((error) => {
            this.isLoading = false 
            window.scrollTo({
              top: 0, 
              behavior: 'smooth',
            });

            this.$router.push('maintenance');
          });
        },
        isImageModalActive(key) {
          this.imageCurr = this.articles[key]
          this.imageModal = true
         
        },
        formatApiDate(apiDate){
          let formatDate = dayjs(apiDate).format('DD MMMM YYYY');
          return formatDate;
        },
        loadData(){
          this.articleSize += 6;
          if(this.articleSize >= this.dataLength){
            this.hideButton = true;
          }
        },
        viewDetail(url){
          if(url!==null){
            window.open(url, '_blank').focus();
          }else{
            this.$buefy.toast.open('PDF file not available')
          }
        },
        setArticlesAndDataLength(filteredList){
          this.articles = filteredList;
          this.dataLength = filteredList.length;
        },
        setIndex(index){
          this.counter = index;
          return index;
        }
      }
    }
  </script>
  
  <style scoped lang="scss">

// .newsDivider {
//   max-height: 455px;
//   height: 100%;
// }

:deep() {
  .modal-content {
    width: 80%;
    margin: 2rem;
  }

  .btn-close {
    position: absolute;
    top: 1vw;
    right: 1vw;
    cursor: pointer;
    z-index: 1;
  }
}

.modal {
  .card-image {
    width: 50%;
    height: 700px;
    border-radius: 0;
    img {
      border-radius: 0;
    }
  }

  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 45%;
    text-align: left;
    padding: 0 5.106vw;
    border-radius: 0;

    .yellow-line {
      width: 100%;
      height: 0px;
      border: 3px solid #FDB913;
      display: block;
      text-align: center;
      margin: 2rem auto ;
    }
    .text-description {
      color: #730039;
      font-weight: 700;
    }

    .author {
      font-style: italic;
      font-weight: 400;
      letter-spacing: 0.01em;
      color: #363636;
      margin: 1rem 0;
    }

    .published-date {
      font-style: normal;
      font-weight: 400;
      font-size: 0.75rem;
      line-height: 20px;
      color: #363636;
    }
  }
}

  
  .date{
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #5C5D64;
  }
  
  .column{
    // padding-left: 40px;
    float: left; 
    position: relative; 
  }

  .image {
    object-fit: cover;
    height: 100%;
    width: 100%;
      img {
        object-fit: cover;
        height: 100%;
        width: 100%;
      }
  }
  
  .text-link{
    text-decoration-line: underline;
    color: #2F469C;
    font-weight: 600;
    font-size: 15px;
    line-height: 26px;
    position: absolute; 
    bottom: 0; 
    left: 40px;
  }
  
  .title{
    color: #2F469C;
    font-size: 41px; 
    font-weight: 700;
  }
  
  .hero {
    font-family: 'Open Sans', sans-serif !important;
  }

  @media (min-width: 768px) and (max-width: 1500px){

    :deep() {
      .modal-content {
        max-width: 800px !important;
      }

      .modal {
        .card-image {
          height: 400px;
        }
      }
    }
  }
  
  
  @media screen and (max-width:1023px) {
    // .section{
    //   margin-left: 10px !important;
    //   margin-right: 0px !important;
    // }
  
    .news-columns{
      padding: 0px !important;
    }
    
    .title{
      margin-bottom: 3rem !important;
    }
  }
  
  @media screen and (max-width:768px){

    .modal {
      .card {
        flex-direction: column;

        .card-image, .card-content {
          width: 100%;
          min-height: 300px;
          height: 100%;
         
        }

        .image {
          img {
            min-height: 300px;
          }
        }

        .card-content {
          padding: 2rem;
          
        }
      }
      
    }
  
    .searchbar-margin{
      margin-inline: 0em !important;
    }
  
    .newsDivider{
      border-right: 0px !important;
      padding-bottom: 0px !important;
      // min-height: 250px !important;
    }
  
    .text-link{
      position: static; 
      bottom: auto; 
      left: auto;
    }
  
  }

  @media (min-width:500px) and (max-width:768px) {
    :deep() {
      .modal-content {
        width: 50%;
      }
    }
  }

  @media screen and (max-width:576px){
    .newsDivider {
      // min-height: 170px !important;
    }
  }
  </style>
  